import React, { useState } from "react";

interface CustomButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  width?: string;
  type?: "button" | "submit" | "reset";
}

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  onClick,
  className = "",
  width = "w-80",
  type = "button",
}) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const handleClick = async () => {
    if (onClick) {
      const result = onClick(); 
  
      //@ts-ignore
      if (result instanceof Promise) {
        await result;  
      }
    }
  
    setIsDisabled(true); 
  
    await new Promise(resolve => setTimeout(resolve, 1500));  
    setIsDisabled(false);  
  };  
  return (
    <button
      onClick={handleClick}
      type={type}
      className={`relative group px-5 py-2.5 h-12 bg-gradient-to-r from-primary to-[#02c39a] text-white font-bold rounded-2xl transition-all duration-500 ease-out shadow-lg shadow-primary/20 hover:shadow-primary/40 hover:-translate-y-1 min-w-[120px] outline-none overflow-hidden ${width} ${className} ${
        isDisabled ? "opacity-60 cursor-not-allowed transform-none shadow-none" : ""
      }`}
      disabled={isDisabled}
    >
      <div className="absolute inset-0 bg-white/20 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out skew-x-12"></div>
      <span className="relative flex items-center justify-center gap-2">
        {text}
      </span>
    </button>
  );
};

export default CustomButton;
